import script from "./qiyuegl-5.vue?vue&type=script&setup=true&lang=js"
export * from "./qiyuegl-5.vue?vue&type=script&setup=true&lang=js"

import "./qiyuegl-5.vue?vue&type=style&index=0&id=44f50a7e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44f50a7e"]])

export default __exports__